module.exports = __webpack_public_path__ + "school/img/duomei3ji.57ea5e05.jpg";